module.exports = function(data) {
var __t, __p = '';
__p += '<div class="grid-stack-item-content">\n    <div class="tableEdit widgetEdit edit ' +
((__t = (data.indicator)) == null ? '' : __t) +
'" data-toggle="tooltip" data-placement="top" title="' +
((__t = ( data.tt )) == null ? '' : __t) +
'">\n        <i class="settings fal fa-cog"></i><div class="circle"></div>\n    </div>\n    <div class="table">\n\n    </div>\n</div>\n';
return __p
}